import React from 'react';
import { Zap } from 'lucide-react';

export default function Ticker({ t }) {
  const items = [...t.ticker, ...t.ticker];

  return (
    <div className="relative bg-volt-400 py-4 overflow-hidden -rotate-1 scale-[1.02] shadow-volt-glow">
      <div className="flex w-max animate-marquee gap-0">
        {items.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-6 pr-6 text-ink font-display font-bold text-sm uppercase tracking-[0.15em] whitespace-nowrap"
          >
            {item}
            <Zap size={14} strokeWidth={2.5} fill="currentColor" />
          </span>
        ))}
      </div>
    </div>
  );
}
